import React from 'react';
import { Row, Col } from 'react-bootstrap';
import AdminLayout from '../components/AdminLayout';
import AdminInstructionsCard from '../components/AdminInstructionsCard';
import AdminModelSelector from '../components/AdminModelSelector';
import AdminChatUiSettingsCard from '../components/AdminChatUiSettingsCard';

function InstructAIPage() {
  return (
    <AdminLayout
      title="AI Instruction Center"
      subtitle="Manage model configuration and instruction sets for different assistant use cases."
    >
      <Row className="g-4">
        <Col xl={4}>
          <AdminModelSelector />
        </Col>
        <Col xl={8}>
          <AdminInstructionsCard />
        </Col>
      </Row>
      <Row className="g-4 mt-1">
        <Col xl={12}>
          <AdminChatUiSettingsCard />
        </Col>
      </Row>
    </AdminLayout>
  );
}

export default InstructAIPage;
